import { getCollectionActionTypes } from '@framework/state/Redux/collectionFactory';

export const keyWord = 'LEAGUE_TABLE_RATING_AGENCIES';

export default getCollectionActionTypes(keyWord);
